export default function($) {
  const $body = $('body');
  const updateKioskAdminBar = () => {
    $body.toggleClass('kiosk-admin-bar-hidden', $(window).scrollTop() >= 46);
  };
  updateKioskAdminBar();
  $(window).on('scroll.kioskAdminBar', updateKioskAdminBar);

  let lastScrollTop = 0;
  const $logoBar = $('.js-mobile-logo-bar');
  if ( !$logoBar.length ) return;

  const $urgentWrapper    = $('#urgent-notifications-wrapper');
  const $nonUrgentWrapper = $('#non-urgent-notifications-wrapper');

  const isMobile = () => $(window).width() < 1024;

  const updateNotificationsTop = ( hidden ) => {
    if ( $urgentWrapper.length ) {
      if ( !isMobile() ) {
        $urgentWrapper.css({ top: '', transform: '' });
      } else {
        $urgentWrapper.css({
          top: '16px',
          transform: hidden ? 'translateY(0)' : 'translateY(' + $logoBar.outerHeight() + 'px)',
        });
      }
    }
    if ( $nonUrgentWrapper.length ) {
      if ( !isMobile() ) {
        $nonUrgentWrapper.css('top', '');
      } else {
        $nonUrgentWrapper.css('top', hidden ? '0px' : $logoBar.outerHeight() + 'px');
      }
    }
  };

  const handleScroll = () => {
    if ( !isMobile() ) {
      $logoBar.css('transform', 'translateY(0)');
      updateNotificationsTop( false );
      return;
    }
    const scrollTop = $(window).scrollTop();
    const hidden = scrollTop > lastScrollTop && scrollTop > 100;
    $logoBar.css('transform', hidden ? 'translateY(-100%)' : 'translateY(0)');
    updateNotificationsTop( hidden );
    lastScrollTop = scrollTop;
  };

  $logoBar.css('transition', 'transform 0.3s ease-in-out');
  if ( $urgentWrapper.length ) $urgentWrapper.css('transition', 'transform 0.3s ease-in-out');
  if ( $nonUrgentWrapper.length ) $nonUrgentWrapper.css('transition', 'top 0.3s ease-in-out');

  // Set correct initial top on mobile
  updateNotificationsTop( false );

  $(window).on('scroll', handleScroll);
  $(window).on('resize', handleScroll);

  // --- User menu dropdown ---
  $('.js-user-menu').each( function() {
    const $menu     = $(this);
    const $trigger  = $menu.find('.user-menu-trigger');
    const $dropdown = $menu.find('.user-menu-dropdown');
    if ( !$trigger.length || !$dropdown.length ) return;

    const alignDropdown = () => {
      if ( !isMobile() ) {
        // Desktop : position dropdown just below the sticky header bottom edge
        const $header      = $('.header');
        const triggerRect  = $trigger[0].getBoundingClientRect();
        const headerBottom = $header.length ? $header[0].getBoundingClientRect().bottom : 0;
        $dropdown.css({
          top:   ( headerBottom - triggerRect.bottom + triggerRect.height ) + 'px',
          right: '',
          left:  '',
        });
        return;
      }
      // Mobile : align right edge of dropdown with right edge of trigger avatar
      const rect = $trigger[0].getBoundingClientRect();
      $dropdown.css({
        top:   '',
        right: ( $(window).width() - rect.right ) + 'px',
        left:  'auto',
      });
    };

    const open = () => {
      alignDropdown();
      $dropdown.addClass('user-menu-dropdown-open');
      $trigger.attr('aria-expanded', 'true');
    };

    const close = () => {
      $dropdown.removeClass('user-menu-dropdown-open');
      $trigger.attr('aria-expanded', 'false');
    };

    $trigger.on('click', e => {
      e.stopPropagation();
      $dropdown.hasClass('user-menu-dropdown-open') ? close() : open();
    });

    $(document).on('click', close);

    $(document).on('keydown', e => {
      if ( e.key === 'Escape' ) { close(); $trigger.trigger('focus'); }
    });
  });
}
